import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IKnm } from '../../../APIPackage/KnmModule/interfaces/IKnm';
import { KindResultDecisionCodesEnum } from '../../../APIPackage/CatalogsModule/enums/KindResultDecisionCodesEnum';
import { IDecision } from '../../../APIPackage/DecisionModule/interfaces/IDecision';
import { isLaterThanAdminSetting } from '../validators/isLaterThanAdminSetting';

export const LinkValidationNoPrescriptionMessageText = 'В паспорте отсутствует предписание';

export const LEGACY_NO_PREFILL: unique symbol = Symbol('legacyNoPrefill');
export type LegacyNoPrefill = typeof LEGACY_NO_PREFILL;

export const isSourceCreatedByOldRules = (
  sourceCreated: string | null | undefined,
  settings: IAdminSetting[],
): boolean =>
  !isLaterThanAdminSetting(sourceCreated, settings, AdminSettingCodesEnum.KNM_VALIDATION_4_1_31_STARTS_FROM);

export const hasKnmPrescription = (knm: IKnm): boolean => {
  const decisions = knm.pmErknm
    ? knm.pmErknm.subject?.pmResultDecisions ?? []
    : knm.knmErknm?.organizations?.flatMap(org => org.resultDecisions ?? []) ?? [];

  return decisions.some(
    decision =>
      decision.kindDecision?.code === KindResultDecisionCodesEnum.D_1 ||
      decision.kindDecision?.code === KindResultDecisionCodesEnum.D_7,
  );
};

export const hasDecisionPrescription = (decision: IDecision): boolean =>
  (decision.organization?.decisions ?? []).some(
    item => item.kind?.code === KindResultDecisionCodesEnum.D_1 || item.kind?.code === KindResultDecisionCodesEnum.D_7,
  );
